module.exports = __webpack_public_path__ + "img/ic_wall_type.37b44db2.svg";